import { createStore } from "vuex";

const store = createStore({
    state() {
        return {
            infoModal: false,
            infoModalText: '',
            refreshModal: false,
            refreshModalText: '',
            left_modal_state: false,
            left_modal_title: '로그인',
            is_login: false,
            left_modal_type: 1, // 1: 로그인, 2: 회원가입, 3: 비밀번호 찾기
            user_info_modal_content:'',
            user_info_modal_state:false
        };
    },

    mutations: {
        setInfoModal(state, text) {
            state.infoModal = true;
            state.infoModalText = text;
        },
        closeInfoModal(state) {
            state.infoModal = false;
            state.infoModalText = '';
        },
        setRefreshModal(state, text) {
            state.refreshModal = true;
            state.refreshModalText = text;
        },
        closeRefreshModal(state) {
            state.refreshModal = false;
            state.refreshModalText = '';
        },
        setLeftModalState(state, value) {
            state.left_modal_state = value;
        },
        setLeftModalTitle(state, value) {
            state.left_modal_title = value;
        },
        setLeftModalType(state, value) {
            state.left_modal_type = value;
        },
        setIsLogin(state, value) {
            state.is_login = value;
        },
        setUserInfoModalContent(state, value) {
            state.user_info_modal_state = true
            state.user_info_modal_content = value;
        },
        setUserInfoModalState(state, value) {
            state.user_info_modal_state = value;
        }

    },
    getters: {
        getInfoModal(state) {
            return state.infoModal;
        },
        getInfoModalText(state) {
            return state.infoModalText;
        },
        getLeftModalState(state) {
            return state.left_modal_state;
        },
        getLeftModalTitle(state) {
            return state.left_modal_title;
        },
        getIsLogin(state) {
            return state.is_login;
        },
        getLeftModalType(state) {
            return state.left_modal_type;
        },
        getUserInfoModalContent(state) {
            return state.user_info_modal_content;
        },
        getUserInfoModalState(state) {
            return state.user_info_modal_state;
        },
        getRefreshModal(state) {
            return state.refreshModal;
        },
        getRefreshModalText(state) {
            return state.refreshModalText;
        }
    },
    // vuex에서 비동기 처리를 하고 싶을 때 actions를 사용합니다.(오래 걸리는거)
    actions: {

    }
});

export default store;